import Login from "../pages/login/Login";
import AdminLogin from "../pages/admin/AdminLogin";
import SignIn from "../pages/register/SignIn";
import ForgotPassword from "../pages/forgotPassword/ForgotPassword";
import Home from "../pages/home/Home";
import Collections from "../pages/collections/Collections";
import Contact from "../pages/contact/Contact";
import Description from "../pages/description/Description";
import Checkout from "../pages/checkout/Checkout";

const unProtectedRoutes = [
    {
        path: "/",
        element: <Home />,
    },
    {
        path: "/collections",
        element: <Collections />,
    },
    {
        path: "/contact",
        element: <Contact />,
    },
    {
        path: "/products",
        element: <Collections />,
    },
    {
        path: "/products/:id",
        element: <Description />,
    },
    {
        path: "/checkout",
        element: <Checkout />,
    },
    {
        path: "register",
        element: <SignIn />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword />
    },
    {
        path: "/admin/login",
        element: <AdminLogin />
    },
]
export default unProtectedRoutes;